import axios from "axios";
import { useQuery } from "@tanstack/react-query";

const SERVER_URL = process.env.NEXT_PUBLIC_SERVER_URL;

if (!SERVER_URL) {
  throw new Error("NEXT_PUBLIC_SERVER_URL 환경변수가 설정되지 않았습니다.");
}

export interface BannerItem {
  id: number;
  title: string;
  imageUrl: string;
  linkUrl: string | null;
  startDate: string;
  endDate: string;
  sortOrder: number;
}

interface BannerListResponse {
  result: boolean;
  data: {
    total: number;
    list: BannerItem[];
  };
}

export const bannerListQueryKey = (siteId: number) =>
  ["BANNER_LIST", siteId] as const;

export const getBannerList = async (siteId: number) => {
  try {
    const res = await axios.get<BannerListResponse>(`${SERVER_URL}banner/list/active`, {
      params: { siteId },
    });
    return res.data;
  } catch (err) {
    console.error("배너 목록 조회 실패:", err);
    throw err;
  }
};

export const useGetBanner = (siteId: number) => {
  const { data } = useQuery({
    queryKey: bannerListQueryKey(siteId),
    queryFn: () => getBannerList(siteId),
    enabled: Number.isFinite(siteId),
  });

  return { bannerList: data?.data?.list ?? [] };
};
